export const EVENT_REFRESH_ATTACHMENTS = "REFRESH_ATTACHMENTS";
export const EVENT_VIEW_ATTACHMENT = "VIEW_ATTACHMENT";

export const BIN_COLUMNS = [{ Header: "Bin Id", accessor: "id" }];

export const BRAND_VERIFIED_LOCATION = "Brand Verified";

export const BRAND_VERIFIED_WORKFLOW_TYPE_ID = 2;
